(function () {
  if (!window.msal) {
    console.error('MSAL is not loaded');
    return;
  }

  const url = window.location.origin + '/ic/builder/design/AccommodationPOC/1.0';

  const origin = window.location.origin;
  const pathname = window.location.pathname;

  const msalInstance = new window.msal.PublicClientApplication({
    auth: {
      clientId: '4c3e4269-8737-4150-93ce-2d5fda039da3',
      authority: 'https://login.microsoftonline.com/2e319086-9a26-46a3-865f-615bed576786',
      knownAuthorities: ['login.microsoftonline.com'],
      redirectUri: url,
      postLogoutRedirectUri: url,
      navigateToLoginRequestUrl: true,
    },
    cache: {
      cacheLocation: 'sessionStorage',
      storeAuthStateInCookie: false
    },
    system: {
      iframeHashTimeout: 10000,
    },
  });

  window.authMsal = {
    login: async function () {
      const response = await msalInstance.loginPopup({
        scopes: ['openid', 'profile', 'email']
      });

      return response.account;
    },
    logout: function () {
      return msalInstance.logout();
    },
    getUser: function () {
      const accounts = msalInstance.getAllAccounts();
      return accounts.length ? accounts[0] : null;
    },
    getAccessToken: async function () {
      const account = msalInstance.getAllAccounts();
      if (!account.length) return null;

      const response = await msalInstance.acquireTokenSilent({
        account: account,
        scopes: ["user.read", "openid", "profile", "api://4c3e4269-8737-4150-93ce-2d5fda039da3/BCA_API_Access_NonProd"]
      });
      return response.accessToken;
    },
    isUserInGroup: async function () {
      const account = this.getUser();
      if (!account) return false;

      const tokenResponse = await msalInstance.acquireTokenSilent({
        account,
        scopes: ["user.read", "openid", "profile", "api://4c3e4269-8737-4150-93ce-2d5fda039da3/BCA_API_Access_NonProd"]
      });

      const accessToken = tokenResponse.accessToken;
      const groupObjectId = '08c26301-c8e3-42ac-93f6-7d2c37aa330b';
      const adminObjectId = '4b41f96e-4520-46b7-9dee-bf9f7205fb57';
      const response = await fetch('https://graph.microsoft.com/v1.0/me/checkMemberGroups', {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          groupIds: [groupObjectId, adminObjectId]
        })
      });

      if (!response.ok) {
        console.error('Graph request failed:', response.statusText);
        return false;
      }

      const result = await response.json();
      return result;
    },
    getPhoto: async function () {
      const accessToken = await this.getAccessToken();
      const headers = {
        Authorization: `Bearer ${accessToken}`,
        'content-Type': 'image/jpg',
      };
      const response = await fetch('https://graph.microsoft.com/v1.0/me/photo/$value', {
        method: 'GET',
        headers: headers,
        responseType: 'blob',
      });
      return response;
    }
  };
}());